import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const MAX = { textarea: 2000, address: 200 };

export const DynamicField = ({ field, value, onChange, error }) => {
  const { name, label, type, placeholder, required, help, options } = field;
  const maxLen = field.max || MAX[type] || 200;
  const common = {
    id: name,
    "data-testid": `field-${name}`,
    placeholder: placeholder || "",
  };

  const render = () => {
    switch (type) {
      case "textarea":
        return (
          <div>
            <Textarea
              {...common}
              maxLength={maxLen}
              rows={5}
              value={value || ""}
              onChange={(e) => onChange(name, e.target.value)}
              className="resize-none"
            />
            <div className="text-right text-xs text-slate-400 mt-1">
              {(value || "").length}/{maxLen}
            </div>
          </div>
        );
      case "select":
        return (
          <Select value={value || ""} onValueChange={(v) => onChange(name, v)}>
            <SelectTrigger data-testid={`field-${name}`}>
              <SelectValue placeholder={placeholder || "Alege..."} />
            </SelectTrigger>
            <SelectContent>
              {(options || []).map((opt) => (
                <SelectItem key={opt} value={opt} data-testid={`option-${name}-${opt}`}>
                  {opt}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        );
      case "checkbox":
        return (
          <div className="flex items-center gap-2">
            <Checkbox
              id={name}
              data-testid={`field-${name}`}
              checked={!!value}
              onCheckedChange={(c) => onChange(name, c)}
            />
            <Label htmlFor={name} className="text-sm text-slate-600">
              {placeholder || label}
            </Label>
          </div>
        );
      case "date":
        return (
          <Input
            {...common}
            type="date"
            value={value || ""}
            onChange={(e) => onChange(name, e.target.value)}
          />
        );
      case "number":
        return (
          <Input
            {...common}
            type="number"
            min="0"
            value={value || ""}
            onChange={(e) => onChange(name, e.target.value)}
          />
        );
      case "email":
        return (
          <Input
            {...common}
            type="email"
            maxLength={maxLen}
            value={value || ""}
            onChange={(e) => onChange(name, e.target.value)}
          />
        );
      case "phone":
        return (
          <Input
            {...common}
            type="tel"
            maxLength={maxLen}
            value={value || ""}
            onChange={(e) => onChange(name, e.target.value)}
          />
        );
      default:
        return (
          <Input
            {...common}
            type="text"
            maxLength={maxLen}
            value={value || ""}
            onChange={(e) => onChange(name, e.target.value)}
          />
        );
    }
  };

  return (
    <div className="space-y-1.5">
      {type !== "checkbox" && (
        <Label htmlFor={name} className="text-sm font-medium text-slate-700 dark:text-slate-200">
          {label} {required && <span className="text-red-500">*</span>}
        </Label>
      )}
      {render()}
      {help && <p className="text-xs text-slate-400">{help}</p>}
      {error && (
        <p data-testid={`error-${name}`} className="text-xs text-red-500 font-medium">
          {error}
        </p>
      )}
    </div>
  );
};
